const ShoppingCart = require("./../../Core/ShoppingCart/shopping_cart");
const { renderCusageEtasWarning } = require("./../../Core/Simulator/cusage_etas_warning");

if (typeof (VTE) === 'undefined')
    VTE = {};

VTE.GlobalSimulatorMgr = function (form, opTypeContainer, catContainer, eligibleContainer, inputsContainer, conditionsContainer, catInfo, eligibleWorkGroupId) {
    var pthis = this;

    this.form = form;
    this.opTypeContainer = opTypeContainer;
    this.catContainer = catContainer;
    this.eligibleContainer = eligibleContainer;
    this.inputsContainer = inputsContainer;
    this.conditionsContainer = conditionsContainer;
    this.catInfo = catInfo;
    this.precaInfos = $('#precaInfos');
    this.isEntreprise = $('#is_entreprise');
    this.isBailleur = $('#is_bailleur');
    this.submitInput = $('input[type=submit]');

    this.fzForbiddenConcurrents = ['Antargaz', 'Sogasud', 'Finagaz'];


    /**
     * Renvoie la valeur actuelle d'input donné
     * @param {string} inputName
     * @returns {string} la valeur actuelle de l'input
     */

    (function ($) {
        $.fn.getInputVal = function () {
            var input = this.find('input[type=radio]:checked, input[type!=radio], select').filter(':visible, :not(:disabled)');
            if (input.length == 0 || input.val() === '')
                return null;
            return input.val();
        };
    })(jQuery);
    (function ($) {
        $.fn.setInputVal = function (inputVal) {
            this.find('input[type!=radio], input[type!=radio], select').val(inputVal);
            this.find('input[type=radio]').prop('checked', false).filter('[value="' + inputVal + '"]').prop('checked', true);
            return this;
        };
    })(jQuery);

    /**
     * On veut dans certains cas déclencher l'affichage d'une popup qui indique que
     * la configuration actuelle rend les travaux non éligibles.
     *
     * On fait cela de la manière la plus simple possible: un tableau de
     * couples (fonction d'éligibilité => renvoi faux si non éligible, message à afficher en cas d'inégibilité)
     */
    this.eligibilityConditions = [
        {
            // BAR-TH-168 : surface de capteurs ≥ 8 m² (chauffage + ECS) / ≥ 2 m² (ECS seule).
            // Keyé par la présence du champ SURF_CAPT_SOL (propre à BAR-TH-168) → pas d'ID de fiche en dur.
            cond: function () {
                var surf = $('#SURF_CAPT_SOL');
                if (surf.length === 0)
                    return true; // pas la fiche BAR-TH-168

                var surfVal = surf.getInputVal();
                var usageVal = $('#USAGE_168').getInputVal();
                if (surfVal === null || surfVal === '' || usageVal === null)
                    return true;

                var seuil = (usageVal == 1) ? 8 : (usageVal == 2 ? 2 : null);
                if (seuil === null)
                    return true;

                return parseFloat(surfVal) >= seuil; // true = éligible
            },
            message: "<p>La surface de capteurs est insuffisante pour être éligible à la Prime énergie.</p>"
        },
        {
            // BAR-TH-162 : surface de capteurs hybrides ≥ 6 m² (seuil fixe, sans dépendance à l'usage).
            // Keyé par la présence du champ SURF_CAPT_HYB (propre à BAR-TH-162) → pas d'ID de fiche en dur.
            cond: function () {
                var surf = $('#SURF_CAPT_HYB');
                if (surf.length === 0)
                    return true; // pas la fiche BAR-TH-162

                var surfVal = surf.getInputVal();
                if (surfVal === null || surfVal === '')
                    return true;

                return parseFloat(surfVal) >= 6; // true = éligible
            },
            message: "<p>La surface de capteurs prévue est insuffisante pour être éligible à la Prime énergie (6 m² minimum).</p>"
        },
        {
            cond: function () {
                // Chaudière haute perforamnce collective P3 (129) et sa version SE (131)
                if ($.inArray(pthis.getSelectedWorkId(), [129, 131]) === -1)
                    if (pthis.getSelectedWorkId() != 129 && pthis.getSelectedWorkId() != 131)
                        return true;

                var pacPower = $('#P3_PAC_POWER').getInputVal();
                var chauffPower = $('#P3_CHAUFF_TOT_POWER').getInputVal();
                if (pacPower === null || chauffPower === null)
                    return true;

                return pacPower < 0.4 * chauffPower;
            },
            message: "<p>La puissance des pompes à chaleur installées est supérieure à 40% de la puissance de la nouvelle chaufferie.</p><p>En conséquence vos travaux ne sont pas éligibles à l'obtention de certificats d'économie d'énergie.</p>"
        },
        {
            cond: function () {
                // Récupérateur de chaleur à condensation (253)
                if ($.inArray(pthis.getSelectedWorkId(), [253]) === -1)
                    return true;

                var pacPower = $('#P3_TOT_NEW_PAC_POWER').getInputVal();
                var chauffPower = $('#P3_CHAUFF_TOT_POWER').getInputVal();
                if (pacPower === null || chauffPower === null)
                    return true;

                return pacPower < 0.4 * chauffPower;
            },
            message: "<p>La puissance des pompes à chaleur nouvellement installées est supérieure à 40% de la puissance de la nouvelle chaufferie.</p><p>En conséquence vos travaux ne sont pas éligibles à l'obtention de certificats d'économie d'énergie.</p>"
        },
        {
            cond: function () {
                // Travaux non éligibles en appartement : Chaudière biomasse P2 et P3 (ID 14, 114), AICB P3 (ID 113), CESI P2(20), SSC P2(21), Régulation P2(10)
                if ($.inArray(pthis.getSelectedWorkId(), [114, 10, 14, 20, 21, 113]) === -1)
                    return true;

                var log = $('#LOG').getInputVal();
                if (log == 2 || log == 3)
                    return false;

                return true;
            },
            message: "<p>Ces travaux ne sont pas éligibles en Appartement ou en Immeuble Collectif.</p>"
        },
        {
            cond: function () {
                // Travaux non éligibles en Maison : Isolation toitures terrasses P2 (ID 2), Iso réseau chauffage P2(ID 74), Iso ECS P2 (ID 75)
                if ($.inArray(pthis.getSelectedWorkId(), [2, 74, 75]) === -1)
                    return true;

                var log = $('#LOG').getInputVal();
                if (log == 1)
                    return false;

                return true;
            },
            message: "<p>Ces travaux ne sont pas éligibles en Maison individuelle.</p>"
        },
        {
            cond: function () {
                // Travaux non définis en immeuble collectif: Chaudière haute perf (ID 112)
                if ($.inArray(pthis.getSelectedWorkId(), [112]) === -1)
                    return true;
                return $('#LOG').getInputVal() != 3;
            },
            message: "<p>Ces travaux ne sont pas éligibles pour un immeuble collectif.</p><p>Choisissez la chaudière collective à haute performance énergétique (BAR-TH-107).</p>"
        },
        {
            cond: function () {
                // Rénovation d'éclairage extérieur
                if (pthis.getSelectedWorkId() != 171)
                    return true;

                var effLight = $('#P3_EFFLIGHT').getInputVal();
                var uler = $('#P3_ULOR').getInputVal();
                var ulr = $('#P3_ULR').getInputVal();
                if ((effLight >= 90 && uler <= 1) || (ulr <= 3))
                    return true;
                else if ((effLight >= 70 && uler <= 10) || (ulr <= 15))
                    return true;
                else return false;
            },
            message: "<p>Ces travaux ne sont pas éligibles pour les caractéristiques techniques que vous avez indiquées</p>"
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 204)
                    return true;

                var typeCaisson = $('#TYPE_CAISSON').getInputVal();
                var log = $('#LOG').getInputVal();
                if (log == 1 && typeCaisson == 2)
                    return false;
                else return true;
            },
            message: "<p>Ces travaux ne sont pas éligibles pour les caractéristiques techniques que vous avez indiquées</p>"
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [219, 220]) === -1)
                    return true;

                var p3EligE = $('#P3_ELIG_E').getInputVal();
                var moyenne = $('#P3_TRA_E').getInputVal();
                if (p3EligE >= 2 || moyenne >= 116)
                    return false;
                else return true;
            },
            message: "<p>Ces travaux ne sont pas éligibles.Le niveau d’émissions de CO2 de chaque véhicule doit être inférieur à 116 gCO2/km.</p>"
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [202, 206]) === -1)
                    return true;

                var log = $('#LOG').getInputVal();
                if (log == 1)
                    return false;
                else return true;
            },
            message: "<p>Ces travaux ne sont pas éligibles pour les caractéristiques techniques que vous avez indiquées</p>"
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [111]) === -1)
                    return true;

                var quotationDate = pthis.inputsContainer.find("input[name*=quotation_date]");
                var typePacVal = $('#P3_TYPE_PAC').getInputVal();
                var qDVal = quotationDate.length > 0 ? quotationDate.val().replace(' / ', '-').replace(' / ', '-') : null;
                var val = $('#P3_ETAS').getInputVal();
                var result = /^(\d{2})-(\d{2})-(\d{4})$/.exec(qDVal);
                if (result) {
                    var quotationDateVal = new Date(
                        parseInt(result[3], 10),
                        parseInt(result[2], 10) - 1,
                        parseInt(result[1], 10)
                    );
                }

                var date1 = new Date('09-26-2015');
                var date2 = new Date('09-26-2017');

                if (quotationDateVal >= date1 && quotationDateVal < date2) {
                    if (val != null) {
                        if (typePacVal == 0) {
                            return val >= 117;
                        } else if (typePacVal == 1) {
                            return val >= 102;
                        }
                    }
                }

                if (quotationDateVal >= date2) {
                    if (val != null) {
                        if (typePacVal == 0) {
                            return val >= 126;
                        } else if (typePacVal == 1) {
                            return val >= 111;
                        }
                    }
                }
                ;
            },
            message: "<p>Ces travaux ne sont pas éligibles pour les caractéristiques techniques que vous avez indiqué (ETAS trop faible)</p>"
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [142]) === -1)
                    return true;

                var quotationDate = pthis.inputsContainer.find("input[name*=quotation_date]");
                var typePacVal = $('#P3_TYPE_PAC').getInputVal();
                var puissanceVal = $('#P3_PAC_COL_POWER').getInputVal();
                var qDVal = quotationDate.length > 0 ? quotationDate.val().replace(' / ', '-').replace(' / ', '-') : null;
                var val = $('#P3_ETAS').getInputVal();
                var result = /^(\d{2})-(\d{2})-(\d{4})$/.exec(qDVal);
                if (result) {
                    var quotationDateVal = new Date(
                        parseInt(result[3], 10),
                        parseInt(result[2], 10) - 1,
                        parseInt(result[1], 10)
                    );
                }

                var date1 = new Date('09-26-2015');
                var date2 = new Date('09-26-2017');
                if (puissanceVal != null && puissanceVal <= 400) {
                    if (quotationDateVal >= date1 && quotationDateVal < date2) {
                        if (val != null) {
                            if (typePacVal == 0) {
                                return val >= 117;
                            } else if (typePacVal == 1) {
                                return val >= 102;
                            }
                        }
                    }

                    if (quotationDateVal >= date2) {
                        if (val != null) {
                            if (typePacVal == 0) {
                                return val >= 126;
                            } else if (typePacVal == 1) {
                                return val >= 111;
                            }
                        }
                    }
                    ;
                }
            },
            message: "<p>Ces travaux ne sont pas éligibles pour les caractéristiques techniques que vous avez indiquées</p>"
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [137]) === -1)
                    return true;

                var quotationDate = pthis.inputsContainer.find("input[name*=quotation_date]");
                var typePacVal = $('#P3_TYPE_PAC').getInputVal();
                var puissanceVal = $('#P3_PAC_POWER').getInputVal();
                var qDVal = quotationDate.length > 0 ? quotationDate.val().replace(' / ', '-').replace(' / ', '-') : null;
                var val = $('#P3_ETAS').getInputVal();
                var result = /^(\d{2})-(\d{2})-(\d{4})$/.exec(qDVal);
                if (result) {
                    var quotationDateVal = new Date(
                        parseInt(result[3], 10),
                        parseInt(result[2], 10) - 1,
                        parseInt(result[1], 10)
                    );
                }

                var date1 = new Date('09-26-2015');
                var date2 = new Date('09-26-2017');
                if (puissanceVal != null && puissanceVal <= 400) {
                    if (quotationDateVal >= date1 && quotationDateVal < date2) {
                        if (val != null) {
                            if (typePacVal == 0) {
                                return val >= 117;
                            } else if (typePacVal == 1) {
                                return val >= 102;
                            }
                        }
                    }

                    if (quotationDateVal >= date2) {
                        if (val != null) {
                            if (typePacVal == 0) {
                                return val >= 126;
                            } else if (typePacVal == 1) {
                                return val >= 111;
                            }
                        }
                    }
                    ;
                }
            },
            message: "<p>Ces travaux ne sont pas éligibles pour les caractéristiques techniques que vous avez indiquées</p>"
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [143]) === -1)
                    return true;

                var quotationDate = pthis.inputsContainer.find("input[name*=quotation_date]");
                var typePacVal = $('#P3_TYPE_PAC').getInputVal();
                var puissanceVal = $('#P3_TOT_NEW_PAC_POWER').getInputVal();
                var qDVal = quotationDate.length > 0 ? quotationDate.val().replace(' / ', '-').replace(' / ', '-') : null;
                var val = $('#P3_ETAS').getInputVal();
                var result = /^(\d{2})-(\d{2})-(\d{4})$/.exec(qDVal);
                if (result) {
                    var quotationDateVal = new Date(
                        parseInt(result[3], 10),
                        parseInt(result[2], 10) - 1,
                        parseInt(result[1], 10)
                    );
                }

                var date1 = new Date('09-26-2015');
                var date2 = new Date('09-26-2017');
                if (puissanceVal != null && puissanceVal <= 400) {
                    if (quotationDateVal >= date1 && quotationDateVal < date2) {
                        if (val != null) {
                            if (typePacVal == 0) {
                                return val >= 117;
                            } else if (typePacVal == 1) {
                                return val >= 102;
                            }
                        }
                    }

                    if (quotationDateVal >= date2) {
                        if (val != null) {
                            if (typePacVal == 0) {
                                return val >= 126;
                            } else if (typePacVal == 1) {
                                return val >= 111;
                            }
                        }
                    }
                    ;
                }
            },
            message: "<p>Ces travaux ne sont pas éligibles pour les caractéristiques techniques que vous avez indiquées</p>"
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [257]) === -1)
                    return true;

                var enginePowerVal = $('#P3_VEV').getInputVal();
                if (enginePowerVal > 1000)
                    return false;

            },
            message: "<p>La puissance nominale du moteur doit être inférieure à 1000kW</p>"
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 342) {
                    return true;
                }
                if ($('#PRIVATE_AREA').getInputVal() == 2) {
                    $('input[name*=PRIVATE_AREA]').closest('.field-container').addClass('error');

                    return false;
                } else {
                    $('input[name*=PRIVATE_AREA]').closest('.field-container').removeClass('error');
                }
            },
            message: "<p>Pour être éligible à la prime CEE, travaux ne doivent concerner que les parties privatives.</p>"
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [341, 342]) === -1) {
                    return true;
                }
                if ($('#LOG_LOCATAIRE').getInputVal() == 1) {
                    $('input[name*=LOG_LOCATAIRE]').closest('.field-container').addClass('error');

                    return false;
                } else {
                    $('input[name*=LOG_LOCATAIRE]').closest('.field-container').removeClass('error');
                }
            },
            message: "<p>Le bénéficiaire de la prime ne peut être le locataire ou occupant à titre gratuit du logement.</p>"
        },
        {
            // PE-985-v2 : blocage si residence principale (RES_PRINCIPALE == 1 = OUI) ET LOC_AGE == 2 ET etiquette initiale E/F/G (CLASS_ENR_INIT >= 5)
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [341, 342]) === -1) {
                    return true;
                }
                if ($('#RES_PRINCIPALE').getInputVal() == 1 && $('#LOC_AGE').getInputVal() == 2 && $('#CLASS_ENR_INIT').getInputVal() >= 5 ) {
                    $('select[name*=CLASS_ENR_INIT]').closest('.field-container').addClass('error');

                    return false;
                } else {
                    $('select[name*=CLASS_ENR_INIT]').closest('.field-container').removeClass('error');
                }
            },
            message: "<p>Votre logement n’est pas éligible à une prime CEE, rapprochez-vous de l’Anah pour<br>" +
                "solliciter le Parcours Rénovation d’ampleur.</p>"
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [341, 342]) === -1) {
                    return true;
                }
                if ($('#SURF_25_PERCENT').getInputVal() == 2 ) {
                    $('input[name*=SURF_25_PERCENT]').closest('.field-container').addClass('error');

                    return false;
                } else {
                    $('input[name*=SURF_25_PERCENT]').closest('.field-container').removeClass('error');
                }
            },
            message: "<p>Pour être éligible à la prime CEE, vous devez réaliser au moins deux travaux d’isolation<br>" +
                "qui représentent 25 % de la surface du bâtiment</p>"
        },
    ];

    this.hideInputsConditions = [
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [322]) === -1)
                    return true;
                return false;
            },
            hideList: ['RRC_ERR']
        },
        {
            // TRA-EQ-133 — M1_OCCASION visible seulement si SERVICE_AUTONOMIE = OUI.
            // SERVICE_AUTONOMIE n'existe que sur la fiche occasion → pas besoin de l'id numérique.
            cond: function () {
                if ($('#SERVICE_AUTONOMIE').length === 0)
                    return false;
                return $('#SERVICE_AUTONOMIE').getInputVal() != 1;
            },
            hideList: ['M1_OCCASION']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [306]) === -1)
                    return false;

                var type = $('#PROPELLER_TYPE').getInputVal();
                if (type == 1)
                    return true;
            },
            hideList: ['POWER_RANGE', 'PS_KM']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [306]) === -1)
                    return false;

                var type = $('#PROPELLER_TYPE').getInputVal();
                if (type == 2)
                    return true;
            },
            hideList: ['LIFT_RANGE', 'AM_KM_TONNAGE']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [115, 116]) === -1)
                    return false;
                var log = $('#LOG').getInputVal();
                return log == 1;
            },
            hideList: ['NAPP', 'TCH']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() == 335)
                    if ($('#ETAS_POWER').getInputVal() == 0) {
                        return false;
                    }
                return true;
            },
            hideList: ['PAC_TYPE', 'ETAS_COLD', 'ETAS_CHAUFF']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() == 335)
                    if ($('#ETAS_POWER').getInputVal() == 1) {
                        return false;
                    }
                return true;
            },
            hideList: ['SEER', 'SCOP']
        },
        {
            cond: function () {  // système de condensation frigorifique à haute efficacité
                if ($.inArray(pthis.getSelectedWorkId(), [139, 250]) === -1)
                    return false;
                var scond = $('#SCOND').getInputVal();
                return scond == 0 || scond == 2;
            },
            hideList: ['DeltaTypeCond']
        },
        {
            cond: function () {  // système de condensation frigorifique à haute efficacité
                if ($.inArray(pthis.getSelectedWorkId(), [139, 250]) === -1)
                    return false;
                var scond = $('#SCOND').getInputVal();
                return !(scond == 2);
            },
            hideList: ['DTEAU']
        },
        {
            cond: function () {  // système de condensation frigorifique à haute efficacité
                if ($.inArray(pthis.getSelectedWorkId(), [139, 250]) === -1)
                    return false;
                var deltaType = $('#DeltaTypeCond').getInputVal();
                var scond = $('#SCOND').getInputVal();
                return !(scond == 1 && deltaType == 1);
            },
            hideList: ['DTASEC']
        },
        {
            cond: function () {  // système de condensation frigorifique à haute efficacité
                if ($.inArray(pthis.getSelectedWorkId(), [139, 250]) === -1)
                    return false;
                var deltaType = $('#DeltaTypeCond').getInputVal();
                var scond = $('#SCOND').getInputVal();
                return !(scond == 1 && deltaType == 2);
            },
            hideList: ['DTAHUM']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [129, 131]) === -1)
                    return false;
                var otherEq = $('#P3_OTHER_EQ').getInputVal();
                var chPowerVal = $('#P3_CH_POWER').getInputVal();
                if (otherEq == 0)
                    $('#P3_TOT_NEW_CH_POWER').setInputVal(chPowerVal);
                return (otherEq == 0);
            },
            hideList: ['P3_TOT_NEW_CH_POWER']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [129, 131]) === -1)
                    return false;
                var haspacPower = $('#P3_HAS_PAC_POWER').getInputVal();
                return (haspacPower == 0);
            },
            hideList: ['P3_PAC_POWER']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [142,333]) === -1)
                    return false;
                var haspac = $('#P3_HAS_PAC').getInputVal();
                var pacColPower = $('#P3_PAC_COL_POWER').getInputVal();
                if (haspac == 0)
                    $('#P3_TOT_NEW_PAC_POWER').setInputVal(pacColPower);
                return (haspac == 0);
            },
            hideList: ['P3_TOT_NEW_PAC_POWER']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [156]) === -1)
                    return false;

                var logVal = $('#LOG').getInputVal();
                if (logVal != 3)
                    $('#P3_NHYDRO').setInputVal(1);
                return logVal != 3;
            },
            hideList: ['P3_NHYDRO']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 204)
                    return false;

                var logVal = $('#LOG').getInputVal();
                return logVal == 1;
            },
            hideList: ['NAPP']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 208)
                    return false;

                var typeEclairageVal = $('#P3_ECLAIRAGE_TYPE').getInputVal();
                return typeEclairageVal == 1;
            },
            hideList: ['P3_NBR_LUM', 'P3_TYPE_LED_GESTION']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 208)
                    return false;

                var typeEclairageVal = $('#P3_ECLAIRAGE_TYPE').getInputVal();
                return typeEclairageVal != 1;
            },
            hideList: ['P3_NBR_LAMP']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 227)
                    return false;

                var log = $('#LOG').getInputVal();
                return log == 1;
            },
            hideList: ['NAPP']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 227)
                    return false;

                var log = $('#LOG').getInputVal();
                if (log != 1) {
                    $('#SH').setInputVal(20);
                }
                return log != 1;
            },
            hideList: ['SH']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 233)
                    return false;

                var type = $('#P3_TER_HYDRO_TYPE').getInputVal();
                if (type == 1 || type == 2) {
                    $('P3_TER_SEC2').setInputVal(1);
                }
                return type == 1 || type == 2;
            },
            hideList: ['P3_TER_SEC1']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 233)
                    return false;

                var type = $('#P3_TER_HYDRO_TYPE').getInputVal();
                if (type == 3 || type == 4) {
                    $('P3_TER_SEC1').setInputVal(1);
                }
                return type == 0 || type == 3 || type == 4;
            },
            hideList: ['P3_TER_SEC2']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 236)
                    return false;

                var mat = $('#P3_TRA_MAT').getInputVal();
                if (mat == 1) {
                    $('#P3_TRA_P').setInputVal(1);
                    $('#P3_TRA_KILOM').setInputVal(0);
                }
                return mat == 0 || mat == 1;
            },
            hideList: ['P3_TRA_P', 'P3_TRA_KILOM']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 236)
                    return false;

                var mat = $('#P3_TRA_MAT').getInputVal();
                if (mat == 2) {
                    $('#P3_T_KM').setInputVal(0);
                    $('#P3_TRA_M').setInputVal(1);
                }
                return mat == 2;
            },
            hideList: ['P3_T_KM', 'P3_TRA_M']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 213)
                    return false;
                return true;
            },
            hideList: ['P3_CUSAGE']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 135)
                    return false;
                return true;
            },
            hideList: ['LUMGEST']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 152)
                    return false;
                return true;
            },
            hideList: ['P3_PRESSE_TYPE']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 310)
                    return false;
                var diametre = $('#DIAMETRE').getInputVal();
                if (diametre == 1 && $('#SISO').val() == "") {
                    $('#SISO').setInputVal(0);
                }
                return diametre == 1;
            },
            hideList: ['SISO']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 310)
                    return false;
                var diametre = $('#DIAMETRE').getInputVal();
                if (diametre == 2 && $('#LISO').val() == "") {
                    $('#LISO').setInputVal(0);
                }
                return diametre == 2;
            },
            hideList: ['LISO']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [137, 111, 143, 239]) === -1)
                    return false;
                if (pthis.getSelectedWorkId() == 137) {
                    var puissance = $('#POWER_THERMPAC').getInputVal();
                    if (puissance != null) {
                        if (puissance != 1) {
                            return false ;
                        }
                        return true;
                    } else {
                        var puissance = $('#P3_PAC_POWER').getInputVal();
                        return puissance != null && puissance <= 400
                    }
                } else if (pthis.getSelectedWorkId() == 111) {
                    return true;
                } else if (pthis.getSelectedWorkId() == 143) {
                    return true;
                } else if (pthis.getSelectedWorkId() == 239) {
                    return true;
                }
            },
            hideList: ['P3_COPE']
        },

        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [137, 111, 143, 239]) === -1)
                    return false;

                if (pthis.getSelectedWorkId() == 137) {
                    var puissance = $('#P3_PAC_POWER').getInputVal();
                    return puissance != null && puissance > 400;
                } else if (pthis.getSelectedWorkId() == 143) {
                    var puissance = $('#P3_TOT_NEW_PAC_POWER').getInputVal();
                    return puissance != null && puissance > 400;
                } else if (pthis.getSelectedWorkId() == 239) {
                    var puissance = $('#P3_TOT_NEW_PAC_POWER').getInputVal();
                    return puissance != null && puissance > 400;
                } else if (pthis.getSelectedWorkId() == 11) {
                    return true;
                }
            },
            hideList: ["P3_ETAS"]
        },

        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [130, 137, 193, 143, 244]) === -1)
                    return false;

                $('#P3_SCHAUF').setInputVal(0);

                return true;
            },
            hideList: ['P3_SCHAUF']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [143, 239]) === -1)
                    return false;
                var puissance = $('#P3_TOT_NEW_PAC_POWER').getInputVal();
                return puissance != null && puissance <= 400;
            },
            hideList: ['P3_PAC_COPE']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [312,314]) === -1)
                    return false;

                var $type = $('#TYPE_INSTALL_ISO').getInputVal();
                if($type == 1)
                {
                    $('#NEPI').setInputVal(0);
                }
                return $type == 1;
            },
            hideList: ['NEPI']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [312,314]) === -1)
                    return false;

                var $type = $('#TYPE_INSTALL_ISO').getInputVal();
                if($type == 2)
                {
                    $('#NHI').setInputVal(0);
                }
                return $type == 2;
            },
            hideList: ['NHI', "DN_CANALISATION"]
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [313]) === -1)
                    return false;

                var $type = $('#MOD_INSTALL').getInputVal();
                return $type == 1;
            },
            hideList: ["USAGE_BAT2"]
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [313]) === -1)
                    return false;

                var $type = $('#MOD_INSTALL').getInputVal();
                return $type == 2;
            },
            hideList: ["USAGE_BAT"]
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 231)
                    return false;
                return true;
            },
            hideList: ['SEC7']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 206)
                    return false;
                return true;
            },
            hideList: ['TYPE_CAISSON']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 219)
                    return false;
                $('select[name*="CAT_VEHICLE"]').find('option[value="5"]').hide();
                $('select[name*="CAT_VEHICLE"]').find('option[value="6"]').hide();
                return true;
            },
            hideList: ['NBR_VEHICLE_2025_2026','NBR_VEHICLE_2027']
        },
        {
            cond: function () {
                if (pthis.getSelectedWorkId() != 193)
                    return false;
                $('select[name*="INVOICE_P4_SEC"]').find('option[value="5"]').hide();
                return true;
            },
            hideList: []
        },
        {
            cond: function () {
                var today = new Date();
                var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                if (date >= '2021-03-15') {
                    $('#ERR').setInputVal(2);
                    return true;
                }

                if ($.inArray(pthis.getSelectedWorkId(), [322]) === -1)
                    return false;

                var type = $('#RRC_ERR').getInputVal();
                if (type != 2) {
                    $('#ERR').setInputVal(1);
                    return true;
                }

            },
            hideList: ['ERR']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [349, 352, 353, 354]) === -1) {
                    return false;
                }
                var power = parseInt($('#P3_PAC_COL_POWER').getInputVal());
                var powerTherm = parseInt($('#POWER_THERMPAC').getInputVal());
                if ((power && power <= 400) || (powerTherm && powerTherm == 1)) {
                   return false;
                }

                return true
            },
            hideList: ['P3_ETAS']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [349, 352, 353, 354]) === -1) {
                    return false;
                }
                var power = parseInt($('#P3_PAC_COL_POWER').getInputVal());
                var powerTherm = parseInt($('#POWER_THERMPAC').getInputVal());
                if ((power && power > 400) || (powerTherm && powerTherm == 2)) {
                    if ($('#COP').getInputVal() == 0) {
                        $('#COP').setInputVal(5);
                    }

                    return false;
                } else {
                    $('#COP').setInputVal(0);
                }

                return true;
            },
            hideList: ['COP']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [349, 350, 351, 352, 353, 354]) === -1) {
                    return false;
                }

                if ($('#MORE_PAC').getInputVal() == 1) {
                    return false
                } else {
                    $('#P3_TOT_NEW_PAC_POWER').setInputVal(0);
                }

                return true;
            },
            hideList: ['P3_TOT_NEW_PAC_POWER']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [341, 342]) === -1) {
                    return false;
                }
                $('select[name*="CLASS_ENR_INIT"]').find('option[value="1"]').remove();//A
                $('select[name*="CLASS_ENR_INIT"]').find('option[value="2"]').remove();//B
                $('select[name*="CLASS_ENR_STEP1"]').find('option[value="1"]').remove();//A
                $('select[name*="CLASS_ENR_STEP1"]').find('option[value="6"]').remove();//F
                $('select[name*="CLASS_ENR_STEP1"]').find('option[value="7"]').remove();//G
                $('select[name*="CLASS_ENR_APRES"]').find('option[value="5"]').remove();//E
                $('select[name*="CLASS_ENR_APRES"]').find('option[value="6"]').remove();//F
                $('select[name*="CLASS_ENR_APRES"]').find('option[value="7"]').remove();//G

                return true;
            },
            hideList: ['etiquette_energetique_logement']
        },
        {
            cond: function () {
                if ($.inArray(pthis.getSelectedWorkId(), [341, 342]) === -1) {
                    return false;
                }

                if ($('#ETAPE_2E').getInputVal() != 1) {
                    $('select[name*="CLASS_ENR_STEP1"]').show();

                    return false;
                } else {
                    $("#CLASS_ENR_STEP1").setInputVal(null);
                }

                return true;
            },
            hideList: ['CLASS_ENR_STEP1','FIRST_DOSSIER_REF']
        },
    ];

    this.opTypeContainer = opTypeContainer;
    this.catContainer = catContainer;
    this.eligibleContainer = eligibleContainer;
    this.inputsContainer = inputsContainer;
    this.conditionsContainer = conditionsContainer;
    this.eligibleWorkGroupId = eligibleWorkGroupId

    this.hideContainer = function (container) {
        container.setInputVal(null);
        if (container == this.catContainer) {
            container.addClass('fields-disabled').find('select').attr('disabled', true);
        } else if (container == this.eligibleContainer) {
            $('.form-part-2').hide();
        } else {
            container.hide();
        }

    };

    this.showContainer = function (container) {
        if (container == this.catContainer) {
            container.removeClass('fields-disabled').find('select').removeAttr('disabled');
        } else if (container == this.eligibleContainer) {
            $('.form-part-2').slideDown();
            $('.meta-footer').css({
                'margin-top': '0'
            });
        } else {
            container.show();
        }
    };

    this.filterBlock = function (container, idList) {
        var select = container.find('select');
        if (typeof (select.get(0).initOptions) === 'undefined') {
            select.get(0).initOptions = select.find('option');
        }
        select.find('option').each(function () {
            if ($(this).attr('value') != '') {
                $(this).remove();
            }
        });
        select.get(0).initOptions.each(function () {
            var id = $(this).attr('value');
            if (id == '') return true;
            if (id in idList) {
                select.append($(this));
            }
        });
    };

    this.refresh = function () {
        if (this.eligibleWorkGroupId == 33) { //Pe-948: concessionnaire
            opTypeContainer.setInputVal('transport').hide();
            catContainer.setInputVal('19').hide();
        }
        if (catContainer.getInputVal() == 19) {
            $('#work_inputs_block').find('.category-title').first().html('Détails de l\'opération :'); //only first category-title
        } else {
            $('#work_inputs_block').find('.category-title').first().html('Détails des travaux :');
        }
        if (!this.opTypeContainer && !this.catContainer)
            return;

        var selectedOpType = opTypeContainer.getInputVal();
        if (selectedOpType === null) {
            this.hideContainer(this.catContainer);
            this.hideContainer(this.eligibleContainer);
            this.refreshInputs();
            this.refreshConditions();
            return;
        }

        var isTogglePreca = (this.isEntreprise.getInputVal() != 1 && this.isBailleur.getInputVal() != 1);
        this.togglePreca(
            (selectedOpType == 'residentiel' && isTogglePreca) ||
            (selectedOpType === 'transport' && $.inArray(parseInt(pthis.getSelectedWorkId()), [220, 311, 348, 356]) >= 0 )
        );
        this.showContainer(this.catContainer);
        var acceptedCats = this.catInfo[selectedOpType].categories;
        this.filterBlock(catContainer, acceptedCats);

        var selectedCatId = catContainer.getInputVal();
        if (selectedCatId === null) {
            this.hideContainer(this.eligibleContainer);
            this.refreshInputs();
            this.refreshConditions();
            this.toggleEnterpriseBailleurQuestions(selectedOpType === 'residentiel');
            return;
        }

        this.showContainer(this.eligibleContainer);

        var acceptedWorks = acceptedCats[selectedCatId].works;
        this.filterBlock(this.eligibleContainer, acceptedWorks);

        this.refreshInputs();
        this.toggleEnterpriseBailleurQuestions(selectedOpType === 'residentiel');
        this.refreshConditions();
        this.hideConditionalInputs();
        this.checkEligibility();
        this.toggleEnrQuestions();
        this.toggleEnrCdpQuestions();
        this.toggleVehicleParcTypeQuestion();
        this.toggleRaccordResChaleurQuestion();
        this.toggleVehicleCategoryQuestion();
        this.toggleVeTaxiQuestion();
        this.toggleVehicleM1BatteryFields114();
        this.bindVehicleM1BatteryFields114();
        //tra-eq-130
        if (pthis.getSelectedWorkId() == 348) {
            $("#is_entreprise").show();
            this.personMoralOnChange();
        }
        this.changeQuotationDateLabel();
        this.hideBennesOrduresCatVehicle();
        this.toggleAdemeQuestion();
        this.toggleBusCoachQuestions();
        this.toggleRenoGlobaleBarTh_174_175Question();
        this.toggleCusageEtasWarning();
        this.toggleVuVehiclesSection();
        this.togglePac162Section();
        this.toggleOccasionInfo133();
    };

    this.togglePreca = function (show) {
        if (show) {
            this.precaInfos.show();
        } else {
            this.precaInfos.hide();
            this.precaInfos.find('[name*=nb_hab_foyer]').val(2);
            this.precaInfos.find('[name*=revenu_foyer]').val(0);
        }
    };

    this.personMoralOnChange = function () {
        if (!$('input[name*="[PER_MORALE_TYPE]"][value="3"]').is(':checked')) {
            pthis.togglePreca(false);
        }
        $('input[name*="[PER_MORALE_TYPE]"]').on('change', function () {
            if ($('input[name*="[PER_MORALE_TYPE]"][value="3"]').is(':checked')) {
                pthis.togglePreca(true);
            } else {
                pthis.togglePreca(false);
            }
        })
    }

    // for all transport
    this.changeQuotationDateLabel = function() {
        if (catContainer.getInputVal() == 19) {
            $('#COTATIONDATE').find('label, .input-title').html('Date estimée d\'engagement (ex : date de signature du bon de commande)');
            $('.information-artisan').hide();
        } else {
            $('#COTATIONDATE').find('label, .input-title').html("Date estimée d'engagement des travaux (ex: date d'acceptation du devis)");
            $('.information-artisan').show();
        }
    }//end

    this.toggleEnterpriseBailleurQuestions = function (show) {
        this.isEntreprise.toggle(show);
        this.isEntreprise.find('input')
            .removeAttr('disabled')

        this.isBailleur.toggle(show);
        this.isBailleur.find('input')
            .removeAttr('disabled')
    };

    this.verifyEntrepriseValue = function () {
        var selectedOpType = opTypeContainer.getInputVal();
        if (selectedOpType != "residentiel" && pthis.getSelectedWorkId() != 348) {
            this.isEntreprise.setInputVal(1);
        }
    };

    this.refreshInputs = function () {
        this.inputsContainer.find('.work-input').find('input, select').attr('disabled', 'disabled');
        var workInputs = this.getSelectedWorkInputs();

        if (workInputs.length === 0) {
            this.inputsContainer.hide();
        } else {
            if (workInputs.indexOf("COTATIONDATE") == -1) {
                workInputs.push("COTATIONDATE");
            }

            if (workInputs.indexOf("is_entreprise") != -1) {
                workInputs.splice("is_entreprise", 1);
            }

            this.inputsContainer.find('.work-input').each(function () {
                var id = $(this).attr('id');
                var show = $.inArray(id, workInputs) !== -1 || $.inArray(id, ['ag_offer_type', 'mwh_price', 'is_bailleur', 'oblige_id','etiquette_energetique_logement']) !== -1;
                $(this).toggle(show);
                if ($('[name*="operation_type"]').val() != 'residentiel' && id == 'etiquette_energetique_logement'){
                    $(this).hide();
                }
                if (show)
                    $(this).find('input, select').removeAttr('disabled');
            });

            // Les champs du panier de PAC (PAC_POWER, PAC_ETAS, PAC_COP, PAC_USG) ont leur propre bloc : on ne les compte pas
            // dans la répartition, sinon ils gonflent la moitié « droite » et toutes les questions restent à gauche
            var columnInputs = $.grep(workInputs, function (name) {
                return !/^PAC_(POWER|ETAS|COP|USG)_/.test(name);
            });
            // « Énergie de chauffage avant travaux » + « Combustible de chauffage avant travaux » : toujours
            // regroupées en tête de la colonne de droite. Le reste est réparti en deux moitiés, en comptant ces
            // deux questions pour garder des colonnes équilibrées.
            var rightFirst = $.grep(['CDP_ENR', 'CDP_ENR_COMB'], function (name) {
                return $.inArray(name, columnInputs) !== -1;
            });
            var otherInputs = $.grep(columnInputs, function (name) {
                return $.inArray(name, rightFirst) === -1;
            });
            var leftCount = Math.floor(columnInputs.length / 2);
            var leftInputs = otherInputs.slice(0, leftCount);
            var rightInputs = rightFirst.concat(otherInputs.slice(leftCount));

            // Trier les inputs suivant l'ordre des inputs des travaux
            for (var i = 0; i < leftInputs.length; i++) {
                var field = $('#' + leftInputs[i]);
                field.detach().appendTo(this.inputsContainer.find('#work-list-1'));

            }
            for (var i = 0; i < rightInputs.length; i++) {
                var field = $('#' + rightInputs[i]);
                field.detach().appendTo(this.inputsContainer.find('#work-list-2'));
            }

            this.inputsContainer.show();
            //tra-eq-130
            this.toggleIsEntrepriseQuestion();
        }
    };

    this.refreshConditions = function () {
        var targetArea = this.conditionsContainer.find('#conditions_html');
        var selectedWorkId = this.getSelectedWorkId();
        if (selectedWorkId === null) {
            this.hideContainer(this.conditionsContainer);
            targetArea.html('');
            return;
        }
        var opType = this.opTypeContainer.getInputVal();
        var catId = this.catContainer.getInputVal();
        var conditionsHtml = this.catInfo[opType].categories[catId].works[selectedWorkId].conditions_html;

        // Si pas de conditions d'éligibilité, on masque la zone
        if (!conditionsHtml) {
            this.conditionsContainer.hide();
            targetArea.html('');
            return;
        }
        $('#conditions_container').html(conditionsHtml);
        this.showContainer(this.conditionsContainer);
    };

    this.getSelectedWorkInputs = function () {
        var selectedWorkId = this.getSelectedWorkId();
        if (selectedWorkId === null) {
            return [];
        }

        var opType = this.opTypeContainer.getInputVal();
        var catId = this.catContainer.getInputVal();

        return this.catInfo[opType].categories[catId].works[selectedWorkId].input_list;
    };

    this.hideConditionalInputs = function () {
        for (var i = 0; i < this.hideInputsConditions.length; i++) {
            var cond = this.hideInputsConditions[i].cond;
            var hideList = this.hideInputsConditions[i].hideList;
            var doHide = cond();
            for (var j = 0; j < hideList.length; j++) {
                var inputName = hideList[j];
                if (inputName == 'RRC_ERR')
                    continue;
                // On ne veut pas faire de show/hide, sinon les champs ne sont pas postés
                // => et on a une erreur de validation
                var opts = doHide ? {visibility: 'hidden', position: 'absolute'} : {
                    visibility: 'visible',
                    position: 'static'
                };
                $('#' + inputName).css(opts);
            }
        }
    };

    /**
     * Récupère l'id des travaux sélectionnés
     * @returns int l'identifiant des travaux sélectionnés
     */
    this.getSelectedWorkId = function () {
        var selectedWorkId = parseInt(this.eligibleContainer.getInputVal());
        return isNaN(selectedWorkId) ? null : selectedWorkId;
    };

    // TRA-EQ-133 — affiche le bloc info occasion (immat 2017-2023 + batterie ≥80 %) uniquement pour cette fiche
    this.toggleOccasionInfo133 = function () {
        $('#occasion-info-133').toggleClass('hidden', pthis.getSelectedWorkId() != 356);
    };

    this.checkEligibility = function () {
        var popupContainer = $('<div>');
        var displayPopup = false;
        for (var i = 0; i < this.eligibilityConditions.length; i++) {

            var condObj = this.eligibilityConditions[i];
            if (condObj.cond() !== false) {
                continue;
            }

            displayPopup = true;
            popupContainer.append(condObj.message);
        }

        if (displayPopup) popupContainer.dialogMp();
    };

    this.toggleEnrQuestions = function () {
        // Si EN(E)R ne fait pas partie des questions des travaux sélectionnés, il ne faut rien faire
        if ($.inArray('ENR', this.getSelectedWorkInputs()) === -1 && $.inArray('ENER', this.getSelectedWorkInputs()) === -1) {
            return;
        }

        // L'input de type d'énergie peut s'appeler ENR ou ENER, en fonction des travaux
        var enr = $.inArray('ENR', this.getSelectedWorkInputs()) !== -1 ? $('#ENR') : $('#ENER');
        var enrComb = $('#ENR_COMB');
        var fzConcurrent = $('#fz_concurrent');

        enrComb.find('input, select').removeAttr('disabled');
        fzConcurrent.find('input, select').removeAttr('disabled');
        enrComb.detach().insertBefore(this.inputsContainer.find('.work-input:last'));
        fzConcurrent.detach().insertAfter(enrComb);

        if (enrComb.length > 0) {
            enrComb.before(enr);
            enr.show();
            enr.find('input, select').removeAttr('disabled');
        }

        var enrVal = enr.getInputVal();
        if (!enrVal || enrVal == 1) {
            // $(enrComb, fzConcurrent).hide().each(function () {
                // $(this).find('input:radio').removeAttr('checked');
                // $(this).find('select').val('');
            // });
            enrComb.hide();
        } else if (enrVal == 2) {
            enrComb.show();
        }
        ;

        var enrCombVal = enrComb.getInputVal();
        if (enrCombVal == 2) {
            fzConcurrent.show();
        } else {
            fzConcurrent.hide().setInputVal('');
        }

        // Mettons à jour les champs cachés 'client finagaz nouveau/existant', en fonction du concurrent
        var concurrent = $('select[name*=fz_concurrent]').val();
        var newClient = $('input[name*=new_client]');
        var existingClient = $('input[name*=existing_client]');
        // if(concurrent == '') {
        //     existingClient.val(0);
        //     newClient.val(0);
        // }
        // else {
        //     existingClient.val(concurrent === 'Finagaz' ? 1 : 0);
        //     newClient.val(enr == 2 && ((enrComb == 2 && $.inArray(concurrent, pthis.fzForbiddenConcurrents) === -1)) ? 1 : 0);
        // }
    };

    this.toggleEnrCdpQuestions = function () {
        if ($.inArray('CDP_ENR', this.getSelectedWorkInputs()) === -1) {
            return;
        }

        if (!$('#CDP_ENR').find('input:checked').val() || $('#CDP_ENR').find('input:checked').val() == 1) {
            $('#CDP_ENR_COMB').hide();
            $('#IS_COND_CHAUD_TERTIAIRE').hide();
        } else {
            $('#CDP_ENR_COMB').show();
        }
    };

    this.toggleCusageEtasWarning = function () {
        var cusageContainer = $('#CUSAGE');
        if (!cusageContainer.length) {
            return;
        }

        renderCusageEtasWarning({
            cusageContainer: cusageContainer,
            selectedCategoryId: parseInt(pthis.catContainer.getInputVal(), 10),
            selectedWorkId: parseInt(pthis.getSelectedWorkId(), 10),
            selectedCusageValue: parseInt(cusageContainer.find('input:checked').val(), 10)
        });
    };

    // Enregistrement des triggers de rafraichissement
    var refreshTriggers = this.opTypeContainer.find('select').add(this.catContainer.find('select')).add(this.eligibleContainer.find('select')).add(this.inputsContainer.find('input, select'));
    refreshTriggers.change(function () {
        pthis.refresh();
    });

    $(document).ready(function () {
        pthis.form.find('input[type=text][data-unit]').each(function () {
            $(this).attr('placeholder', $(this).data('unit'));
        });
    });

    //TRA-EQ-114
    function showNbrVehicle() {
        $('#NBR_VEHICLE_2025_2026, #NBR_VEHICLE_2027').css({'visibility':'visible', 'position':'relative'});
        $('#P3_NBR_CAR').css({'visibility':'hidden', 'position':'absolute'}).setInputVal(0);
        $('select[name*="[CAT_VEHICLE]"]').find('option[value="5"]').show();
        $('select[name*="[CAT_VEHICLE]"]').find('option[value="6"]').show();
        $('select[name*="[CAT_VEHICLE]"]').find('option[value="3"]').hide();
        $('select[name*="[CAT_VEHICLE]"]').find('option[value="4"]').hide();
    }
    function hideNbrVehicle() {
        $('#NBR_VEHICLE_2025_2026, #NBR_VEHICLE_2027').css({'visibility':'hidden', 'position':'absolute'}).setInputVal(0);
        $('#P3_NBR_CAR').css({'visibility':'visible', 'position':'relative'});
        $('select[name*="[CAT_VEHICLE]"]').find('option[value="5"]').hide();
        $('select[name*="[CAT_VEHICLE]"]').find('option[value="6"]').hide();
        $('select[name*="[CAT_VEHICLE]"]').find('option[value="3"]').show();
        $('select[name*="[CAT_VEHICLE]"]').find('option[value="4"]').show();
    }
    this.toggleVehicleParcTypeQuestion = () => {
        if (pthis.getSelectedWorkId() == 219) {
            if ($('select[name*="[PARC_TYPE]"]').val() == 3) {
                showNbrVehicle();
            } else {
                hideNbrVehicle()
            }
            $('select[name*="[PARC_TYPE]"]').on('change', function () {
                $('select[name*="[CAT_VEHICLE]"]').find('option:selected').prop("selected", false);
                if ($(this).val() == 3) {
                    showNbrVehicle();
                } else {
                    hideNbrVehicle();
                }
            });
        }
    }

    //Reno Global
    this.toggleRenoGlobaleBarTh_174_175Question = function() {
        if ($.inArray(pthis.getSelectedWorkId(), [341, 342]) === -1) {
            return;
        }
        $('#LOG_LOCATAIRE').find('.input-title label').html("Le bénéficiaire est-il locataire ou occupant à titre gratuit du logement ?");
        //pro not need this question
        // $('#is_entreprise').hide();
        // if (pthis.getSelectedWorkId() == 342) {
        //     $('#is_entreprise').setInputVal(1);
        // } else {
        //     $('#is_entreprise').setInputVal(0);
        // }

        $('select[name*="CLASS_ENR_INIT"]').on('change', function () {
            var selectedVal = parseInt($(this).val());
            var target = $('select[name*="CLASS_ENR_APRES"], select[name*="CLASS_ENR_STEP1"]');
            // hide all options
            target.find('option').hide();
            // show options from 1 to selected value
            for (var i = 1; i < selectedVal-1; i++) { //2 saut
                target.find('option[value="' + i + '"]').show();
            }
        });

        $('select[name*="CLASS_ENR_STEP1"]').on('change', function () {
            var selectedVal = parseInt($(this).val());
            var target = $('select[name*="CLASS_ENR_APRES"]');
            // hide all options
            target.find('option').hide();
            // show options from 1 to selected value
            for (var i = 1; i < selectedVal; i++) { //1 saut
                target.find('option[value="' + i + '"]').show();
            }
        });
    }

    //TRA-EQ-129
    this.hideBennesOrduresCatVehicle = function () {
        if (pthis.getSelectedWorkId() == 347) {
            if ($('select[name*="[PARC_TYPE_2]"]').val() == 1) {
                $('select[name*="[CAT_VEHICLE_3]"]').find('option[value="7"]').hide();
            } else {
                $('select[name*="[CAT_VEHICLE_3]"]').find('option[value="7"]').show();
            }
        }
    }

    // TRA-EQ-128 (work 346) : hors agglomération (PARC_TYPE_2 = 1) → catégorie « autocar »
    // (CAT_VEHICLE_2_AUTOCAR) à la place de « autobus » (CAT_VEHICLE_2). Question ADEME pour
    // standard / grande capacité (2, 3), question EEE du kit pour rétrofit (1). Champs masqués désactivés.
    this.toggleBusCoachQuestions = function () {
        var $busCat = $('[name*="[CAT_VEHICLE_2]"]').closest('.field-container');
        var $coachCat = $('[name*="[CAT_VEHICLE_2_AUTOCAR]"]').closest('.field-container');
        var $ademe = $('[name*="[VU_ADEME_BUS]"]').closest('.field-container');
        var $eee = $('[name*="[RETROFIT_EEE]"]').closest('.field-container');
        var setVisible = function ($c, visible) {
            if (visible) {
                $c.show().find('input, select').removeAttr('disabled');
            } else {
                $c.hide().find('input, select').attr('disabled', 'disabled');
            }
        };
        var is128 = pthis.getSelectedWorkId() == 346;
        var isAutocar = $('select[name*="[PARC_TYPE_2]"]').val() == 1;
        var cat = parseInt((isAutocar ? $('select[name*="[CAT_VEHICLE_2_AUTOCAR]"]') : $('select[name*="[CAT_VEHICLE_2]"]')).val());
        setVisible($busCat, is128 && !isAutocar);
        // refreshInputs répartit les champs en deux colonnes d'après input_list : la catégorie autobus tombe
        // dans la colonne de gauche. On la place en tête de la colonne de droite, comme la version autocar.
        if (is128 && !isAutocar) {
            var $col2 = $('#work-list-2');
            var $busField = $('#CAT_VEHICLE_2');
            if ($col2.length && $busField.length && !$col2.children().first().is($busField)) {
                $busField.detach().prependTo($col2);
            }
        }
        setVisible($coachCat, is128 && isAutocar);
        setVisible($ademe, is128 && $.inArray(cat, [2, 3]) !== -1);
        setVisible($eee, is128 && cat === 1);
        $('select[name*="[PARC_TYPE_2]"], select[name*="[CAT_VEHICLE_2]"], select[name*="[CAT_VEHICLE_2_AUTOCAR]"]')
            .off('change.buscoach128').on('change.buscoach128', pthis.toggleBusCoachQuestions);
    }

    //TRA-EQ-129 : question ADEME (bonification achat/location) masquée en rétrofit (VEHICLE_TYPE = 2)
    this.toggleAdemeQuestion = function () {
        if (pthis.getSelectedWorkId() == 347) {
            var ademe = $('#VU_ADEME_PL');
            if ($('select[name*="[VEHICLE_TYPE]"]').val() == 2) {
                ademe.hide().find('input, select').attr('disabled', 'disabled');
            } else {
                ademe.show().find('input, select').removeAttr('disabled');
            }
        }
    }

    //tra-eq-130
    if (window.location.href.split('.')[0].split('/').indexOf('entreprises') < 0) {
        $('#PER_MORALE_TYPE').hide();
    } else {
        $('input[name*="[PER_MORALE_TYPE]"][value="1"]').prop('checked', true);
    }
    this.toggleIsEntrepriseQuestion = () => {
        if (pthis.getSelectedWorkId() == 348) {
            if (parseInt($('input[name*="[is_entreprise]"]:checked').val()) != 1) {
                $('input[name*="[is_entreprise]"][value="0"]').prop('checked', true);
                // if (window.location.href.split('.')[0].split('/').indexOf('entreprises') < 0) {
                //     $('#PER_MORALE_TYPE').hide();
                // } else {
                //     $('input[name*="[PER_MORALE_TYPE]"][value="1"]').prop('checked', true);
                // }
            }
            $("#is_entreprise").show();
            $('#is_entreprise').find('input[name*="[is_entreprise]"]').on('change', function () {
                $('#PER_MORALE_TYPE').find('input:radio[name*="PER_MORALE_TYPE"]:checked').prop('checked', false);
                if ($(this).val() == 1) {
                    $('#PER_MORALE_TYPE').show();
                } else {
                    $('#PER_MORALE_TYPE').hide();
                }
            });
        }
    }

    //TRA-EQ-117
    function showHideVehicleCategoryQuestion(inputValue) {
        var $m1Fields   = $('[name*="[VEHICLE_LEGER_M1_MINIMAL]"], [name*="[EU_BATTERIE]"]').closest('.field-container');
        var $inputBeChecked = $('input[name*="[VEHICLE_LEGER_M1_MINIMAL]"][value="2"], input[name*="[EU_BATTERIE]"][value="2"]');
        var $vuFields   = $('[name*="[VU_MASSE]"], [name*="[VU_EEE]"]').closest('.field-container');

        if (inputValue == 1) {
            // Véhicule léger neuf : M1/batterie visibles, VU masqués
            $m1Fields.toggle(true).find('input, select').removeAttr('disabled');
            $vuFields.toggle(false).find('input, select').attr('disabled', 'disabled');
        } else if (inputValue == 2) {
            // Véhicule utilitaire léger neuf : M1/batterie masqués (pré-cochés NON), VU visibles
            $inputBeChecked.prop('checked', true);
            $m1Fields.toggle(false).find('input, select').attr('disabled', 'disabled');
            $vuFields.toggle(true).find('input, select').removeAttr('disabled');
        } else {
            // Pas de sélection : tout masqué
            $inputBeChecked.prop('checked', true);
            $m1Fields.toggle(false).find('input, select').attr('disabled', 'disabled');
            $vuFields.toggle(false).find('input, select').attr('disabled', 'disabled');
        }
    }

    this.toggleVehicleCategoryQuestion = () => {
        var $vuFields = $('[name*="[VU_MASSE]"], [name*="[VU_EEE]"]').closest('.field-container');
        if (pthis.getSelectedWorkId() == 220) {
            // Pour work 220 v83 : seules les options 1 (léger) et 2 (utilitaire léger) sont pertinentes
            $('select[name*="[CAT_VEHICLE_1]"]').find('option[value="3"], option[value="4"], option[value="5"], option[value="6"]').hide();
            // Appliquer l'état initial dès la sélection du work
            showHideVehicleCategoryQuestion($('select[name*="[CAT_VEHICLE_1]"]').val());
            $('select[name*="[CAT_VEHICLE_1]"]').off('change.vu117').on('change.vu117', function () {
                showHideVehicleCategoryQuestion($(this).val());
                pthis.toggleRevenuFoyerFields();
            });
        } else {
            $vuFields.toggle(false).find('input, select').attr('disabled', 'disabled');
        }
        pthis.toggleRevenuFoyerFields();
    }

    // VE_TAXI : propre à TRA-EQ-117 (220, champ catégorie CAT_VEHICLE_1) et TRA-EQ-114
    // (219, champ catégorie CAT_VEHICLE) — visible uniquement pour les catégories de véhicule léger
    // (1, 3, 5), même filtre catVehicle que le barème décile (cf. toggleRevenuFoyerFields).
    // Ces champs catégorie sont partagés par tous les works : sans le filtre sur le work sélectionné,
    // leur valeur (conservée d'une sélection précédente, ou pré-remplie par défaut) faisait apparaître
    // VE_TAXI même pour des fiches sans rapport (ex: TRA-EQ-121 - vélo à assistance électrique).
    this.toggleVeTaxiQuestion = () => {
        var $veTaxi = $('[name*="[VE_TAXI]"]').closest('.field-container');
        if ($veTaxi.length === 0) {
            return;
        }
        var applyVisibility = () => {
            var workId = pthis.getSelectedWorkId();
            var catVehicleSelector = workId == 220 ? 'select[name*="[CAT_VEHICLE_1]"]'
                : (workId == 219 ? 'select[name*="[CAT_VEHICLE]"]' : null);
            var catVehicle = catVehicleSelector ? parseInt($(catVehicleSelector).val()) : null;
            $veTaxi.toggle(catVehicleSelector !== null && $.inArray(catVehicle, [1, 3, 5]) !== -1);
        };
        applyVisibility();
        $('select[name*="[CAT_VEHICLE_1]"], select[name*="[CAT_VEHICLE]"]').off('change.vetaxi').on('change.vetaxi', applyVisibility);
    }

    // TRA-EQ-114 (work 219) : chaînage véhicule léger neuf (CAT_VEHICLE=1) → VE_TAXI=OUI →
    // VEHICLE_LEGER_M1_MINIMAL, puis VEHICLE_LEGER_M1_MINIMAL=OUI → EU_BATTERIE. Si VE_TAXI = NON,
    // rien de plus n'est affiché. Propre à 219 uniquement (ne touche pas 220/TRA-EQ-117, dont le
    // comportement existant — M1/batterie affichés dès "léger", indépendamment de VE_TAXI — reste
    // inchangé). Les réponses masquées sont remises à NON pour ne pas rester "coincées" sur OUI.
    this.toggleVehicleM1BatteryFields114 = () => {
        // Work 220 (TRA-EQ-117) gère ces mêmes champs lui-même via showHideVehicleCategoryQuestion/
        // toggleVehicleCategoryQuestion : on ne touche à rien pour ne pas lui rentrer en conflit.
        // Pour tout autre work (219 inclus), on pilote nous-mêmes la visibilité ci-dessous — y compris
        // pour la masquer si l'utilisateur quitte 219 pour un work sans rapport (champs catégorie
        // partagés entre works, cf. commentaire de toggleVeTaxiQuestion).
        if (pthis.getSelectedWorkId() == 220) {
            return;
        }

        var $m1 = $('[name*="[VEHICLE_LEGER_M1_MINIMAL]"]').closest('.field-container');
        var $battery = $('[name*="[EU_BATTERIE]"]').closest('.field-container');
        if ($m1.length === 0) {
            return;
        }

        var catVehicle = parseInt($('select[name*="[CAT_VEHICLE]"]').val());
        var isLeger = pthis.getSelectedWorkId() == 219 && catVehicle == 1;
        var isTaxi = $('input[name*="[VE_TAXI]"]:checked').val() == 1;

        var showM1 = isLeger && isTaxi;
        if (showM1) {
            $m1.toggle(true).find('input, select').removeAttr('disabled');
        } else {
            $m1.toggle(false).find('input, select').attr('disabled', 'disabled');
            $m1.find('input[value="2"]').prop('checked', true);
        }

        var showBattery = showM1 && $('input[name*="[VEHICLE_LEGER_M1_MINIMAL]"]:checked').val() == 1;
        if (showBattery) {
            $battery.toggle(true).find('input, select').removeAttr('disabled');
        } else {
            $battery.toggle(false).find('input, select').attr('disabled', 'disabled');
            $battery.find('input[value="2"]').prop('checked', true);
        }
    }
    this.bindVehicleM1BatteryFields114 = () => {
        $('select[name*="[CAT_VEHICLE]"]').off('change.m1battery114').on('change.m1battery114', pthis.toggleVehicleM1BatteryFields114);
        $('input[name*="[VE_TAXI]"]').off('change.m1battery114').on('change.m1battery114', pthis.toggleVehicleM1BatteryFields114);
        $('input[name*="[VEHICLE_LEGER_M1_MINIMAL]"]').off('change.m1battery114').on('change.m1battery114', pthis.toggleVehicleM1BatteryFields114);
    }

    // TRA-EQ-117 : le seuil de prix de VEHICLE_LEGER_M1_MINIMAL passe de 47 000 à 65 000 €
    // quand le véhicule est utilisé comme taxi (VE_TAXI = OUI) - cf. simulator front équivalent.
    this.toggleVehicleTaxiPriceLabel = () => {
        var $label = $('#VEHICLE_LEGER_M1_MINIMAL .input-title label');
        if ($label.length === 0) {
            return;
        }
        var isTaxi = $('input[name*="[VE_TAXI]"]:checked').val() == 1;
        var text = $label.text();
        if (isTaxi && text.indexOf('47 000') !== -1) {
            $label.text(text.replace('47 000', '65 000'));
        } else if (!isTaxi && text.indexOf('65 000') !== -1) {
            $label.text(text.replace('65 000', '47 000'));
        }
    }

    // TRA-EQ-117/121/130/133 : remplace [precarity][nb_hab_foyer]/[precarity][revenu_foyer]
    // par NBR_PARTS/VE_REVENU_FOYER (barème décile, affiché pour ces 4 fiches transport).
    // GROS_ROULER (tranches intermédiaires 6/7/8, jamais si VE_TAXI = OUI) et VE_TAXI restent
    // propres à TRA-EQ-117 (véhicule léger) — 121/130/133 n'ont pas ces questions.
    this.toggleRevenuFoyerFields = () => {
        var catVehicle = parseInt($('select[name*="[CAT_VEHICLE_1]"]').val());
        var workId = pthis.getSelectedWorkId();
        // TRA-EQ-117 (220) : seule la catégorie "léger" (impair) utilise le barème décile —
        // 121/130/133 (311/348/356) n'ont pas de notion de catégorie véhicule.
        var catVehicleOk = workId != 220 || $.inArray(catVehicle, [1, 3, 5]) !== -1;
        var isGrosRouleurDecileWork = $.inArray(workId, [220, 311, 348, 356]) !== -1 && catVehicleOk;
        var isGrosRouleurQuestionWork = workId == 220 && catVehicleOk;

        var $oldFields = $('[name*=nb_hab_foyer], [name*=revenu_foyer]').closest('.field-container');
        var $newFields = $('[name*=NBR_PARTS], [name*=VE_REVENU_FOYER]').closest('.field-container');
        var $grosRouleur = $('[name*=GROS_ROULER]').closest('.field-container');

        $oldFields.toggle(!isGrosRouleurDecileWork);
        $newFields.toggle(isGrosRouleurDecileWork);

        pthis.toggleVehicleTaxiPriceLabel();

        if (!isGrosRouleurQuestionWork) {
            $grosRouleur.hide().find('input:checked').prop('checked', false);
            return;
        }

        var $revenuFoyer = $('select[name*=VE_REVENU_FOYER]');
        var updateGrosRouleur = () => {
            var isTaxi = $('input[name*="[VE_TAXI]"]:checked').val() == 1;
            var isApplicable = !isTaxi && $.inArray(parseInt($revenuFoyer.val()), [6, 7, 8]) !== -1;
            $grosRouleur.toggle(isApplicable);
            if (!isApplicable) {
                $grosRouleur.find('input:checked').prop('checked', false);
            }
        };
        updateGrosRouleur();
        $revenuFoyer.off('change.gr117').on('change.gr117', updateGrosRouleur);
        $('input[name*="[VE_TAXI]"]').off('change.taxi117').on('change.taxi117', function () {
            updateGrosRouleur();
            pthis.toggleVehicleTaxiPriceLabel();
        });
    }

    //TRA-EQ-126
    this.resetTraEq126TotalHours = () => {
        if (pthis.getSelectedWorkId() == 335 && $('select[name*=BATEAU_TYPE]').val() == 1) {
            totalUsedHoursElm = $('input[name*=TOTAL_USED_HOURS]');
            if (parseInt(totalUsedHoursElm.val()) > 275) {
                totalUsedHoursElm.val(275)
            }
        }
    }

    // bar-th-177
    // Désactive tous les inputs des champs masqués avant soumission (évite la validation Symfony des questions conditionnelles)
    // pthis.form.on('submit', function () {
    //     pthis.form.find('.work-input:hidden, .field-container:hidden').find('input, select, textarea').attr('disabled', 'disabled');
    // });

    this.submitInput.click(function (e) {
        e.preventDefault();
        if ($('input[name*=HORS_RRC]:checked').val() == 1 && pthis.getSelectedWorkId() == 343) {
            if ($('#hors_rrc-error-modal').length > 0) {
                setTimeout(function () {
                    $('#hors_rrc-error-modal').dialogMp();
                }, 1000);
                $('input[name*=HORS_RRC]').siblings('label').find('.radio-btn').css('border-color','#F44336')
                return;
            }
        }
        if ($('input[name*=NB_APPART]').val() < 3 && pthis.getSelectedWorkId() == 343) {
            if ($('#nb_appart-error-modal').length > 0) {
                setTimeout(function () {
                    $('#nb_appart-error-modal').dialogMp();
                }, 1000);
                $('input[name*=NB_APPART]').parent().parent().addClass('error');
                return;
            }
        }
        if ($('input[name*=SURF_TOT]').val() > 10000 && pthis.getSelectedWorkId() == 344) {
            if ($('#surf_tot-error-modal').length > 0) {
                setTimeout(function () {
                    $('#surf_tot-error-modal').dialogMp();
                }, 1000);
                $('input[name*=SURF_TOT]').parent().parent().addClass('error');
                return;
            }
        }
        if (pthis.getSelectedWorkId() == 171) { //RES-EC-104
            if ((parseInt($("input[name*='NLIGHT]']").val()) + parseInt($("input[name*='LUM_REEQUIP]']").val())) < 10 && $('#nlight-control-modal').length > 0) {
                setTimeout(function () {
                    $('#nlight-control-modal').dialogMp();
                }, 1000);
                $("input[name*='NLIGHT]']").parent().parent().addClass('error');
                $("input[name*='LUM_REEQUIP]']").parent().parent().addClass('error');
                return;
            }
            if (parseInt($("input[name*='NLIGHT2]']").val()) < 10 && $('#nlight-control-modal').length > 0) {
                setTimeout(function () {
                    $('#nlight-control-modal').dialogMp();
                }, 1000);
                $("input[name*='NLIGHT2]']").parent().parent().addClass('error');
                return;
            }
        }
        if (pthis.getSelectedWorkId() == 348 && parseInt($("input[name*='NAPP]']").val()) > 1 && parseInt($("input[name*='LOG]']:checked").val()) == 1) { //BAR-TH-127
            if ($('#napp-control-modal').length > 0) {
                setTimeout(function () {
                    $('#napp-control-modal').dialogMp();
                }, 1000);
                $("input[name*='NAPP]']").parent().parent().addClass('error');
                return;
            }
        }

        if (pthis.getSelectedWorkId() == 335 && $.inArray($('select[name*=DEPT]').val(), ['20', '21', '97', '98', '99', '100', '101', '102', '103', '104']) !== -1 ) {//BAT-TH-158 && outre mer
            if ($('#bat-th-158-outre-mer-error-modal').length > 0) {
                setTimeout(function () {
                    $('#bat-th-158-outre-mer-error-modal').dialogMp();
                }, 1000);
                $('select[name*=DEPT]').addClass('error');
                return;
            }
        }

        //BAR-TH-173
        if (pthis.getSelectedWorkId() == 340 && parseInt($("input[name*='NBR_EMETTEUR_EQUIP]']").val()) < 2) {
            if ($('#nbr_emetteur_equip-modal').length > 0) {
                setTimeout(function () {
                    $('#nbr_emetteur_equip-modal').dialogMp();
                }, 1000);
                $("input[name*='NBR_EMETTEUR_EQUIP]']").parent().parent().addClass('error');
                return;
            }
        }

        var date_31_12_2024 = new Date(2024,11,31); // month between 0-11
        if (pthis.getSelectedWorkId() == 317 &&  new Date() < date_31_12_2024) { //bar-th-163 be closed on 01/01/2025
            var quotationDate = pthis.inputsContainer.find("input[name*=quotation_date]");
            var qDVal = quotationDate.length > 0 ? quotationDate.val().replace(' / ', '-').replace(' / ', '-') : null;
            var result = /^(\d{2})-(\d{2})-(\d{4})$/.exec(qDVal);
            if (result) {
                var quotationDateVal = new Date(
                    parseInt(result[3], 10),
                    parseInt(result[2], 10) - 1,
                    parseInt(result[1], 10)
                );
            }

            $('#bar-th-163-closing-error-modal').dialogMp();

            if ($('#bar-th-163-closing-error-modal').length > 0 && quotationDateVal > date_31_12_2024) {
                quotationDate.parent().parent().addClass('error');
                return;
            }

        }
        //
        if ($.inArray(ShoppingCart.getSubdomain(), ['pro', 'www', 'entreprises']) > -1) {
            var targetUserId = $('input:hidden[name*=target_user_id]').val();

            let response;

            if (typeof targetUserId === "undefined" || targetUserId.length == 0) {
                response = ShoppingCart.simulationAlreadyInCart(pthis.getSelectedWorkId(), "nouveau");
            } else if (targetUserId.length > 0) {
                response = ShoppingCart.simulationAlreadyInCart(pthis.getSelectedWorkId(), targetUserId);
            }

            pthis.resetTraEq126TotalHours();

            if (!response.exists || window.location.href.indexOf(response.item_id) > -1) {
                // Trick pour verifier la valeur du champ is_entreprise
                pthis.verifyEntrepriseValue();
                if (pthis.getSelectedWorkId() == 317 &&  new Date() < date_31_12_2024) { //bar-th-163 be closed on 01/01/2025
                    setTimeout(function () {
                        pthis.form.submit();
                    }, 4000);
                } else {
                    pthis.form.submit();
                }
            } else {
                ShoppingCart.showExistingSimulationInCartPopUp(response.edit_url, response.eligible_work_title);
            }
        } else {
            // Trick pour verifier la valeur du champ is_entreprise
            pthis.verifyEntrepriseValue();
            if (pthis.getSelectedWorkId() == 317 &&  new Date() < date_31_12_2024) { //bar-th-163 be closed on 01/01/2025
                setTimeout(function () {
                    pthis.form.submit();
                }, 4000);
            } else {
                pthis.form.submit();
            }
        }
    });


    this.toggleRaccordResChaleurQuestion = (e) => {
        if ($('input[name="ash_administration[HEAT_NETWORK_CONNECTION]"]').val() == 1) {
            $('input[name="ash_administration[IS_CONNECTION_CERTIFIED]"]').show();
        } else {
            $('input[name="ash_administration[IS_CONNECTION_CERTIFIED]"]').hide();
        }
    }

    //TRA-EQ-114 v83 — section véhicules utilitaires dynamique
    var VU_WORK_ID = 219;

    this.toggleVuVehiclesSection = function () {
        var section = $('#VU_VEHICLES_SECTION');
        if (!section.length) return;

        var $p3NbrCar = $('#P3_NBR_CAR');

        if (pthis.getSelectedWorkId() !== VU_WORK_ID) {
            section.hide();
            section.find('input, select').attr('disabled', 'disabled');
            return;
        }

        // Pour work 219 v83 : seules les options 1 (léger) et 2 (utilitaire léger) sont pertinentes
        $('select[name$="[CAT_VEHICLE]"]').find('option[value="3"], option[value="4"], option[value="5"], option[value="6"]').hide();

        // CAT_VEHICLE = 1 → véhicule léger : P3_NBR_CAR visible, section VU masquée
        // CAT_VEHICLE = 2 → véhicule utilitaire léger : P3_NBR_CAR masqué, section VU visible
        var catVal = parseInt($('select[name$="[CAT_VEHICLE]"]').val());

        if (catVal === 2) {
            $p3NbrCar.hide().find('input, select').attr('disabled', 'disabled');
            section.show();
            section.find('.vu-vehicle-row:visible').find('input, select').removeAttr('disabled');
            section.find('.vu-vehicle-row:hidden').find('input, select').attr('disabled', 'disabled');
        } else {
            $p3NbrCar.show().find('input, select').removeAttr('disabled');
            section.hide();
            section.find('input, select').attr('disabled', 'disabled');
        }
    };

    $('#vu-add-row').on('click', function () {
        var next = $('.vu-row-extra:hidden').first();
        if (next.length) {
            next.show();
            next.find('input, select').removeAttr('disabled');
        }
        if (!$('.vu-row-extra:hidden').length) {
            $(this).hide();
        }
    });

    $(document).on('click', '.vu-row-remove', function () {
        var row = $(this).closest('.vu-vehicle-row');
        row.find('select').val('');
        row.find('input[type=number], input[type=text]').val(1);
        row.find('input[type=radio]').prop('checked', false);
        row.find('input, select').attr('disabled', 'disabled');
        row.hide();
        $('#vu-add-row').show();
    });
    //fin TRA-EQ-114 v83

    // BAR-TH-178 (work 349), BAR-TH-179 (350), BAR-TH-180 (351), BAT-TH-162 (352), BAT-TH-163 (353) et BAT-TH-164 (354) — usages du système géothermique + panier de PAC
    var PAC_WORK_IDS = [349, 350, 351, 352, 353, 354];
    var PAC_POWER_THRESHOLD = 400; // kW : <= 400 → Etas, > 400 → COP
    var PAC_WORK_IDS_USAGE_PER_PAC = [350, 351]; // 179 / 180 : Etas seul (pas de COP) + usage choisi pour chaque PAC
    var PAC_WORK_IDS_USAGE_CHECKS = [349, 352]; // 178 / 162 : coches d'usage du système

    // Affiche l'Etas (P <= 400 kW ou non saisie) ou le COP (P > 400 kW) et n'active que le champ affiché
    var syncPac162Row = function ($row) {
        var power = parseFloat(String($row.find('.pac162-power').val()).replace(',', '.'));
        var $etas = $row.find('.pac162-etas-container');
        var $cop = $row.find('.pac162-cop-container');
        var $usage = $row.find('.pac162-usage-container');
        var usageMode = $('#PAC_SECTION').hasClass('pac162-usage-mode');
        // Puissance non saisie : ni Etas ni COP (on ne sait pas encore lequel s'applique)
        var hasPower = !isNaN(power);
        // Fiche sans COP (BAR-TH-179 / 180) : l'Etas s'applique quelle que soit la puissance
        var isCop = hasPower && !usageMode && power > PAC_POWER_THRESHOLD;
        var showEtas = hasPower && !isCop;
        var rowActive = $row.is(':visible');
        // Sans puissance, l'Etas reste masqué mais garde sa place (visibility) pour ne pas décaler les colonnes
        $etas.toggle(showEtas || !hasPower).css('visibility', hasPower ? 'visible' : 'hidden');
        $cop.toggle(isCop);
        $etas.find('input').prop('disabled', !rowActive || !showEtas);
        $cop.find('input').prop('disabled', !rowActive || !isCop);
        $usage.toggle(usageMode);
        $usage.find('input').prop('disabled', !rowActive || !usageMode);
    };

    this.togglePac162Section = function () {
        var section = $('#PAC_SECTION');
        if (!section.length) return;

        if ($.inArray(pthis.getSelectedWorkId(), PAC_WORK_IDS) === -1) {
            section.hide();
            section.find('input, select').attr('disabled', 'disabled');
            return;
        }

        var workId = pthis.getSelectedWorkId();
        section.toggleClass('pac162-usage-mode', $.inArray(workId, PAC_WORK_IDS_USAGE_PER_PAC) !== -1);
        var usageChecks = $.inArray(workId, PAC_WORK_IDS_USAGE_CHECKS) !== -1;
        $('#PAC_USAGES').toggle(usageChecks);
        // Chauffage reste verrouillé (toujours coché) ; ECS / rafraîchissement actifs uniquement pour 178 / 162
        $('.pac162-usage-cb').not('[data-target="PAC_USG_CHAUF"]').prop('disabled', !usageChecks);
        section.show();
        section.find('.pac162-row').each(function () {
            var $row = $(this);
            $row.find('.pac162-power').prop('disabled', !$row.is(':visible'));
            syncPac162Row($row);
        });
        if (typeof checkPac162Total === 'function') checkPac162Total();
    };

    // Puissance, Etas, COP : chiffres uniquement, avec un seul séparateur décimal (virgule ou point)
    $(document).on('input', '.pac162-number', function () {
        var cleaned = $(this).val().replace(/[^0-9.,]/g, '');
        var firstSeparator = cleaned.search(/[.,]/);
        if (firstSeparator !== -1) {
            cleaned = cleaned.slice(0, firstSeparator + 1) + cleaned.slice(firstSeparator + 1).replace(/[.,]/g, '');
        }
        if (cleaned !== $(this).val()) {
            $(this).val(cleaned);
        }
    });

    // Contrôle : somme des puissances des PAC <= puissance totale de la chaufferie après travaux
    var PAC_TOTAL_MESSAGE = 'La puissance totale de la chaufferie après travaux doit être supérieur ou égale à la somme de la puissance des PAC installées';
    var checkPac162Total = function () {
        var $container = $('#P3_CHAUFF_TOT_POWER');
        if (!$container.length) return;

        var $message = $container.find('.pac162-total-error');
        var sum = 0;
        if ($('#PAC_SECTION').is(':visible')) {
            $('#PAC_SECTION .pac162-row:visible .pac162-power').each(function () {
                var value = parseFloat(String($(this).val()).replace(',', '.'));
                if (!isNaN(value)) sum += value;
            });
        }
        var chauffage = parseFloat(String($container.find('input').first().val()).replace(',', '.'));

        if (sum > 0 && !isNaN(chauffage) && chauffage < sum) {
            if (!$message.length) {
                $message = $('<div class="pac162-total-error"></div>').text(PAC_TOTAL_MESSAGE)
                    .css({color: 'red', fontSize: '13px', fontWeight: 800, margin: '5px 0 0'});
                $container.append($message);
            }
        } else {
            $message.remove();
        }
    };

    $(document).on('input change', '.pac162-power, #P3_CHAUFF_TOT_POWER input', checkPac162Total);
    $(document).on('click', '.pac162-row-remove', function () { setTimeout(checkPac162Total, 0); });

    $(document).on('input change', '.pac162-power', function () {
        syncPac162Row($(this).closest('.pac162-row'));
    });

    $(document).on('change', '.pac162-usage-cb', function () {
        $('[name*="[' + $(this).data('target') + ']"]').val($(this).is(':checked') ? 1 : 0);
    });

    $('#pac162-add-row').on('click', function () {
        var next = $('.pac162-row-extra:hidden').first();
        if (next.length) {
            next.show();
            next.find('.pac162-power').prop('disabled', false);
            syncPac162Row(next);
        }
        if (!$('.pac162-row-extra:hidden').length) {
            $(this).hide();
        }
    });

    $(document).on('click', '.pac162-row-remove', function () {
        var row = $(this).closest('.pac162-row');
        row.find('input[type=radio]').prop('checked', false);
        row.find('input:not([type=radio])').val('');
        row.hide();
        row.find('input').attr('disabled', 'disabled');
        $('#pac162-add-row').show();
    });
    // fin BAT-TH-162

    // On souhaite initialiser l'affichage à l'instanciation
    this.refresh();
};

$(document).ready(function () {

    if ($('#confirmModal').length > 0) {
        let formValidate = $('form[name*=app_user_registration]');
        formValidate.on('submit', function (e) {
            e.preventDefault(); // Bloque la soumission normale
            $('#confirmModal').modal('show');
            // Bouton "Retour"
            $('#modal-back').off('click').on('click', function () {
                $('#confirmModal').modal('hide');
            });
            // Bouton "Confirmer"
            $('#modal-confirm').off('click').on('click', function () {
                $('#confirmModal').modal('hide');
                // Soumission native (évite les doubles submit)
                formValidate[0].submit();
            });
        })
        $('.marypopin-close').on('click', function () {
            $('#confirmModal').modal('hide');
        });
    }
});


